// DEPRECATED
// include the common-script in your pack, rather than this pack

import '@polleverywhere/toolkit/vendor/javascripts/modernizr.slim'

import '../common-script/dropdown'
